/**
 * Identifies advertisement message transaction type
 * tag: 5
 * @readonly
 * @enum {string} (String)
 */
export enum AdvTransType {
  /** New */
  New = 'N',
  /** Cancel */
  Cancel = 'C',
  /** Replace */
  Replace = 'R',
}
